import { useState } from "react";
import SelectSearch from "../../../../Core/Fields/Floating/SelectSearch";
const Tab2 = ({ SupplierPrimaryAddress, SupplierPrimaryContact }) => {
  return (
    <>
      <div
        className="row mb-3"
        style={{ border: "1px solid #00000059", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Primary Address and Contact</p>
        </div>

        <div className="col-6">
          <div
            className={
              SupplierPrimaryAddress.Error ? `mb-3 errorborder` : `mb-3`
            }
          >
            <SelectSearch
              list={SupplierPrimaryAddress.SupplierPrimaryAddress_list}
              
              label="Supplier Primary Address"
              getOptionLabel={(item) =>
    item.isNew ? "+ Create New Address" : item.name
  }
  getOptionValue={(item) => item.name}
              createNewUrl="/master/address/create-address"
  createNewLabel="Create New Address"
              value={SupplierPrimaryAddress.SupplierPrimaryAddress}
              onChange={(val) => SupplierPrimaryAddress.setselect_SupplierPrimaryAddress_list(val)}
            />
            {/* <SelectSearch
              list={SupplierPrimaryAddress.SupplierPrimaryAddress_list}
              style={{
                height: "30px",
                border: SupplierPrimaryAddress.Error ? "1px solid red" : "",
              }}
              label="Supplier Primary Address"
              getOptionLabel={(item) => item.name} // 👈 Required
              getOptionValue={(item) => item.name} // 👈 Required
              value={SupplierPrimaryAddress.select_SupplierPrimaryAddress}
              onChange={(val) =>
                SupplierPrimaryAddress.setselect_SupplierPrimaryAddress(val)
              }
            /> */}
            <p
              style={{
                paddingLeft: "14px",
                paddingRight: "14px",
                fontWeight: 400,
                fontSize: "9px",
                lineHeight:'2',
                letterSpacing: "0",
                color: "#00000099",
                fontFamily: "Roboto, sans-serif",
              }}
            >
              Reselect, if the chosen address is edited after save
            </p>
          </div>
        </div>
        <div className="col-6">
          <div
            className={
              SupplierPrimaryContact.Error ? `mb-3 errorborder` : `mb-3`
            }
          >
            <SelectSearch
              // list={SupplierPrimaryContact.SupplierPrimaryContact_list}
              
              label="Supplier Primary Contact"
              getOptionLabel={(item) =>
    item.isNew ? "+ Create New Contact" : item.name
  }
  getOptionValue={(item) => item.name}
              createNewUrl="/master/create-contact"
  createNewLabel="Create New Contact"
              value={SupplierPrimaryContact.SupplierPrimaryContact}
              onChange={(val) => SupplierPrimaryContact.setselect_SupplierPrimaryContact(val)}
            />
            {/* <SelectSearch
              list={SupplierPrimaryContact.SupplierPrimaryContact_list}
              style={{
                height: "30px",
                border: SupplierPrimaryContact.Error ? "1px solid red" : "",
              }}
              label="Supplier Primary Contact"
              getOptionLabel={(item) => item.name} // 👈 Required
              getOptionValue={(item) => item.name} // 👈 Required
              value={SupplierPrimaryContact.select_SupplierPrimaryContact}
              onChange={(val) =>
                SupplierPrimaryContact.setselect_SupplierPrimaryContact(val)
              }
            /> */}
            <p
              style={{
                paddingLeft: "14px",
                paddingRight: "14px",
                fontWeight: 400,
                lineHeight:'2',
                fontSize: "9px",
                letterSpacing: "0",
                color: "#00000099",
                fontFamily: "Roboto, sans-serif",
              }}
            >
              Reselect, if the chosen address is edited after save
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Tab2;
